import { Box, GridItem, Heading, Flex, Badge } from "@chakra-ui/react";
import { FC } from "react";
import { Avatar } from "components/avatar";
import { TeamUserListingItemGrid } from "./teamUserListingItemGrid";
import { InviteListingItemMenu } from "./inviteListingItemMenu";
import { TeamInvite } from "lib/types";

export const InviteListingItem: FC<{ invite: TeamInvite }> = ({ invite }) => (
  <Box
    w={"100%"}
    layerStyle={["with-box-shadow-light"]}
    borderRadius={"md"}
    pr={[3, 4]}
    pl={[3, 4]}
    pt={3}
    pb={3}
    bgColor={"bg.50"}
  >
    <TeamUserListingItemGrid>
      <GridItem colSpan={1}>
        <Avatar
          data={{
            name: `${invite.match}`,
          }}
          size="sm"
        />
      </GridItem>
      <GridItem rowSpan={1}>
        <Flex alignItems={['center', 'center', 'flex-start']} gridGap={['0px', '0px', '20px']} flexDirection={['column', 'column', 'row']}>
          <Heading fontSize={["sm", "md"]}>{invite.match}</Heading>
          <Badge variant="solid" colorScheme="brand" position="relative" bottom="-1px">pending</Badge>
        </Flex>
      </GridItem>
      <GridItem>
        <InviteListingItemMenu invite={invite} />
      </GridItem>
    </TeamUserListingItemGrid>
  </Box>
);